<template>
  <div
    class="programs-list"
    :key="`programs-list--${visibleProgramsType}`"
  >
    <program-element
      v-for="(program, i) in programs"
      :key="`programs-list__program--${program.name}`"
      :program="program"
      :is-first="i === 0"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ProgramElement from '@/components/ProgramElement.vue'

export default {
  name: 'programs-list',
  props: {
    programs: {
      type: Array,
      default: () => ([]),
    }
  },
  computed: {
    ...mapGetters({
      visibleProgramsType: 'visibleProgramsType',
    }),
    visiblePrograms() {
      if (!this.visibleProgramsType) return this.programs
      return this.programs.filter(program => program.type === this.visibleProgramsType)
    }
  },
  mounted() {
    this.collapseAllAndOpenFirst()
  },
  methods: {
    ...mapMutations({
      setVisibleProgramsType: 'setVisibleProgramsType',
      setVisibleProgramsAmount: 'setVisibleProgramsAmount',
    }),
    async collapseAllAndOpenFirst() {
      await this.$nextTick()
      this.$root.$emit('programs.collapse.all')
      this.$root.$emit('programs.uncollapse.first')
    }
  },
  watch: {
    visibleProgramsType: 'collapseAllAndOpenFirst',
    visiblePrograms: {
      handler(programs) {
        const amount = programs.length
        this.setVisibleProgramsAmount({ amount })
      },
      immediate: true
    }
  },
  components: {
    ProgramElement
  },
}
</script>

<style lang="scss" scoped>
.programs-list {
  @include layout-container;

  padding: 16px 0 0;
}
</style>
